<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button v-if="isDisplayConfirmButton()"
					   class="md-sm md-primary"
					   @click="showConfirm"
			>
				{{ $t("common.confirm") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	methods: {
		showConfirm() {
			const { params } = this.params.colDef;
			const { data } = this.params;
			params.showConfirm(data);
		},
		isDisplayConfirmButton() {
			return enumDef.ipuRequestStatus.canBeConfirmed(this.params.data.status);
		}

	}
};
</script>